import { Accordion } from '@sbab-ui/components'

interface Props {
  children: React.ReactNode
  handleOnClick: () => void
  className?: string
}

export default function AccordionTriggerWithClick({
  children,
  handleOnClick,
  ...props
}: Readonly<Props>) {
  return (
    <Accordion.Trigger {...props} onClick={() => handleOnClick()}>
      {children}
    </Accordion.Trigger>
  )
}
